import { CSSProperties } from 'react';
import { ISliderIndents } from '../../types';

interface IGetButtonWrapperStyleParams {
  indents: ISliderIndents;
}

export function getButtonWrapperStyle(params: IGetButtonWrapperStyleParams): CSSProperties {
  const { indents } = params;
  const { top = 0, bottom = 0 } = indents;

  return {
    top: `calc(50% - ${top}px - ${bottom}px)`,
  };
}
